

















import { Component, Vue } from "vue-property-decorator";
import CpComplianceList from "@/components/cp-compliance/CpComplianceList.vue";
import CpComplianceDashboard from "@/components/cp-compliance/CpComplianceDashboard.vue";

@Component({
  components: { CpComplianceList, CpComplianceDashboard }
})
export default class CpCompliancePage extends Vue {
  tab = 0;
}
